'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { signOut } from '@/auth-client';

/**
 * Sign-in button. Triggers OAuth flow via BetterAuth client.
 * @param {{ className?: string }} props - optional CSS class for the link
 */
export function SignIn(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = `header-nav-link ${className ?? ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Link href="/sign-in" className={t1} data-umami-event="auth-signin">Sign In</Link>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}

/** Sign-out button. Revokes session and redirects to '/'. */
export function SignOut() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button type="button" className="header-nav-link cursor-pointer" data-umami-event="auth-signout" onClick={_temp}>Sign Out</button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return signOut();
}